// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Json from "../primitives/Json.res.js";
import * as React from "react";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as ReactUpdateEffect from "../primitives/ReactUpdateEffect.res.js";
import * as ReactUpdateDebounced from "../primitives/ReactUpdateDebounced.res.js";

function read(key, decoder) {
  try {
    let jsonState = Stdlib_Option.map(Primitive_option.fromNull(localStorage.getItem(key)), Json.parseExn);
    if (jsonState === undefined) {
      return;
    }
    let persistedState = decoder(jsonState);
    if (persistedState.TAG === "Ok") {
      return Primitive_option.some(persistedState._0);
    }
    localStorage.removeItem(key);
    return;
  } catch (_parsingError) {
    localStorage.removeItem(key);
    return;
  }
}

function store(state, key, encoder) {
  let jsonStringifiedState = Json.stringify(encoder(state));
  localStorage.setItem(key, jsonStringifiedState);
}

function useRead(key, decoder) {
  return React.useState(() => read(key, decoder))[0];
}

function usePersistOnChange(state, key, disabledOpt, debounceDelayOpt, encoder, decoder, param) {
  let disabled = disabledOpt !== undefined ? disabledOpt : false;
  let debounceDelay = debounceDelayOpt !== undefined ? debounceDelayOpt : 0;
  let initialValues = useRead(key, decoder);
  let match = React.useState(() => Stdlib_Option.isSome(initialValues));
  let setPersisted = match[1];
  let debouncedValues = ReactUpdateDebounced.use(state, debounceDelay);
  let debouncing = Primitive_object.notequal(state, debouncedValues);
  ReactUpdateEffect.use1(() => {
    if (!disabled && !debouncing) {
      store(state, key, encoder);
      setPersisted(param => true);
    }
  }, [debouncing]);
  if (match[0]) {
    return !debouncing;
  } else {
    return false;
  }
}

function make(key, encoder, decoder) {
  let read$1 = () => read(key, decoder);
  let store$1 = state => store(state, key, encoder);
  let useRead$1 = () => useRead(key, decoder);
  let usePersistOnChange$1 = (state, disabledOpt, debounceDelayOpt, param) => {
    let disabled = disabledOpt !== undefined ? disabledOpt : false;
    let debounceDelay = debounceDelayOpt !== undefined ? debounceDelayOpt : 0;
    return usePersistOnChange(state, key, disabled, debounceDelay, encoder, decoder, undefined);
  };
  return {
    read: read$1,
    store: store$1,
    useRead: useRead$1,
    usePersistOnChange: usePersistOnChange$1
  };
}

export {
  read,
  store,
  useRead,
  usePersistOnChange,
  make,
}
/* react Not a pure module */
